// src/i18n/en/index.js
import raEnglishMessages from 'ra-language-english'; // Cambio aquí - sin destructuring

// Importar traducciones modulares - Fix de imports
import { zones } from './zones'; // Importar como named export
import { tagTypes } from './tagTypes'; // Importar como named export
import lockerTypes from './lockerTypes'; // Importar lockerTypes
import hotels from './hotels'; // Importar hotels
import groups from './groups'; // Importar groups
import hmis from './hmis'; // Importar hmis
import lockerControllers from './lockerControllers'; // Importar lockerControllers
import lockers from './lockers'; // Importar lockers
import { lockerAssignments } from './lockerAssignments'; // Importar lockerAssignments
import common from './common'; // Importar common
import dashboard from './dashboard'; // Importar dashboard
import users from './users'; // Importar users
import auth from './auth'; // Importar auth
import tags from './tags'; // Importar tags
import hmiSimulator from './hmiSimulator'; // Importar hmiSimulator
import hmiStaff from './hmiStaff';

const en = {
  ...raEnglishMessages, 
  ra: {
    ...raEnglishMessages.ra,
    action: {
      ...raEnglishMessages.ra.action,
      add_filter: 'Add filter',
      saving: 'Saving...',
      more: 'More actions',
      menu: 'Menu',
      clear_input_value: 'Clear field',
      close: 'Close',
      none: 'None'
    },
    auth: {
      ...raEnglishMessages.ra.auth,
      sign_in_error: 'Sign in error. Please check your credentials.',
      logging_in: 'Signing in...',
    },
    navigation: {
      ...raEnglishMessages.ra.navigation,
      page_rows_per_page: 'Rows per page:',
      page_range_info: '%{offsetBegin}-%{offsetEnd} of %{total}',
      page_out_of_boundaries: 'Page number %{page} out of boundaries',
      page_out_from_end: 'Cannot go after last page',
      page_out_from_begin: 'Cannot go before page 1',
      page_empty: 'No records',
      next: 'Next',
      prev: 'Previous',
      page_info: '%{from}-%{to} of %{count}',
      page_rows_per_page_all: 'All',
      partial_page_range_info: '%{offsetBegin}-%{offsetEnd} of %{total}',
      page_range: '%{from}-%{to} of %{count}',
      displayed_records: '%{from}-%{to} of %{count}',
    },
    pagination: {
      page_info: '%{from}-%{to} of %{count}',
      page_info_simple: 'Page %{page}',
      labeled_page_info: '%{from}-%{to} of %{count}',
    },
    page: {
      ...raEnglishMessages.ra.page,
      not_found: 'Page not found',
      error: 'An error occurred',
      dashboard: 'Dashboard',
      create: 'Create',
      edit: 'Edit',
    },
    message: {
      ...raEnglishMessages.ra.message,
      not_found: 'The requested resource was not found',
      error: 'An error occurred. Please try again later',
      delete_title: 'Confirm deletion',
      delete_content: 'Are you sure you want to delete this item?',
      invalid_form: 'The form contains errors. Please review the fields',
    },
    notification: {
      ...raEnglishMessages.ra.notification,
      deleted: 'Element deleted',
    },
  },
  fields: {
    hotel: 'Hotel',
    zone: 'Zone',
    name: 'Name',
    description: 'Description',
    status: 'Status',
    active: 'Active',
    type: 'Type',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    city: 'City',
    country: 'Country',
    createdAt: 'Created at',
    updatedAt: 'Last updated',
    lastSeenAt: 'Last connection',
    isOnline: 'Online',
  },
  common,
  resources: {
    lockers,
    locker_assignments: lockerAssignments,
    users: users,
    hotels: hotels,
    groups: groups,
    tags: tags,
    settings: {
      name: 'Setting |||| Settings',
    },
    tag_types: {
      name: 'Tag Type |||| Tag Types',
    },
    locker_controllers: lockerControllers,
    hmis,
    locker_types: {
      name: 'Locker Type |||| Locker Types',
    },
    hmi_simulator: {
      name: 'HMI Simulator |||| HMI Simulators',
    },
    'tag-types': tagTypes,
    'locker-controllers': lockerControllers,
    'locker-types': lockerTypes,
    'locker-assignments': lockerAssignments,
    'hmi-simulator': {
      name: 'HMI Simulator |||| HMI Simulators',
    },
    'hmi-staff': hmiStaff,
    zones: zones || {},
    tagTypes: tagTypes || {},
    dashboard: dashboard,
    // Grouped pages
    adminOptions: {
      name: 'Admin Options',
      tabs: {
        groups: 'Groups',
        hotels: 'Hotels',
        tag_types: 'ID Types',
        locker_types: 'Locker Types',
        system: 'System',
      },
      help: {
        title: 'Admin Options',
        description: 'Manage the basic system configuration elements.',
        feature_groups: 'Hotel group management',
        feature_hotels: 'Hotel configuration and properties',
        feature_tag_types: 'Tag types for locker access',
        feature_locker_types: 'Available locker type configuration',
      },
    },
    devices: {
      name: 'Devices',
      tabs: {
        controllers: 'Controllers',
        hmis: 'HMI Devices',
        staff: 'HMI Staff',
      },
      help: {
        title: 'Devices',
        description: 'Manage system controllers, HMI terminals and staff.',
        feature_controllers: 'Locker controllers and their network configuration',
        feature_hmis: 'HMI terminals and their configuration',
        feature_staff: 'HMI staff and their PIN access codes',
      },
    },
  },
  dashboard,
  users,
  auth,
  hmiSimulator,
  shell: {
    menu: {
      groups: {
        general: 'General',
        operation: 'Operation',
        administration: 'Administration',
        tools: 'Tools',
      },
    },
  },
  user: {
    profile: 'Profile',
    settings: 'Settings',
    change_password: 'Change Password',
  },
  pages: {
    login: {
      subtitle: 'Sign in to start',
      login_button: 'Sign In',
      forgot_password: 'Forgot your password?',
    },
    forgot_password: {
      title: 'Recover Password',
      subtitle: 'Enter your email and we will send you a link to reset your password',
      email_label: 'Email Address',
      submit_button: 'Send recovery link',
      sending: 'Sending...',
      back_to_login: 'Back to login',
      email_sent: 'Email sent successfully',
      success_message: 'If the email exists in our system, you will receive a password reset link shortly.',
      error: 'An error occurred while processing your request. Please try again.',
    },
    reset_password: {
      title: 'Reset Password',
      new_password: 'New Password',
      confirm_password: 'Confirm Password',
      submit_button: 'Reset Password',
      resetting: 'Resetting...',
      back_to_login: 'Back to login',
      success: 'Password reset successfully',
      success_message: 'Your password has been reset successfully. You will be redirected to the login page in a few moments.',
      redirecting: 'Redirecting to login...',
      error: 'An error occurred while resetting your password. Please try again.',
      passwords_dont_match: 'Passwords do not match',
      password_too_short: 'Password must be at least 6 characters long',
      no_token: 'No valid token provided',
      invalid_token: 'The recovery link is invalid or has expired',
      validation_error: 'Error validating token',
      validating: 'Validating link...',
    },
    dashboard: {
      no_devices: 'No results found',
      no_devices_description: 'No data available at this time',
    },
  },
};

export default en;